import { AllowedUse, AllowedUseAddlOption } from "@mcleod/components";

export const ALLOWED_USE_REPORT_SCHEDULER =
    new AllowedUseAddlOption(AllowedUse.REPORT, "reportScheduler", "Allow this report to be scheduled");
